import { writable } from "svelte/store";
export const isLoading = writable(true);
export class I18NextTranslationStore {
    constructor(i18n) {
        this.i18n = this.createInstance(i18n);
        this.isLoading = this.createLoadingInstance(i18n);
    }
    createInstance(i18n) {
        const i18nWritable = writable(i18n);
        i18n.on('initialized', () => {
            i18nWritable.set(i18n);
        });
        i18n.on('loaded', () => {
            i18nWritable.set(i18n);
        });
        i18n.on('added', () => i18nWritable.set(i18n));
        i18n.on('languageChanged', () => {
            i18nWritable.set(i18n);
        });
        return i18nWritable;
    }
    createLoadingInstance(i18n) {
        // if loaded resources are empty || {}, set loading to true
        i18n.on('loaded', (resources) => {
            Object.keys(resources).length !== 0 && isLoading.set(false);
        });
        // if resources failed loading, set loading to true
        i18n.on('failedLoading', () => {
            isLoading.set(true);
        });
        return isLoading;
    }
}
//# sourceMappingURL=translation-store.js.map